import RenderFormEntities from './entities-options'
import FormActions from './actions'

import ApplicationDetails from './application-details'
import RenderEntityForm from './entity-content'
import { Col } from 'antd'
import { AppState } from '@/state'
import { useFormInstance } from '@/hooks/useForm'

import './styles.scss'

export default function RenderFormTabs() {
  const topbarHidden = AppState.hideTopbar.value

  const { currentForm } = useFormInstance()

  return (
    <div className={`form-tab-view ${topbarHidden ? 'topbar-hidden' : ''}`}>
      <ApplicationDetails />
      <div className='tabs-header'>
        <RenderFormEntities />
        <FormActions form={currentForm} />
      </div>
      <Col xl={24} className='entity-content'>
        <RenderEntityForm form={currentForm} />
      </Col>
    </div>
  )
}
